// extracted by mini-css-extract-plugin
module.exports = {"button":"FixedBook-module--button--1vS4z"};